module.exports = __webpack_public_path__ + "static/image 119-0157a5743a4407fc2455d2b4728eb14d.jpg";